export const loadCSS = (href) => {
  return new Promise((resolve) => {
    // already loaded
    if (document.querySelector(`link[href="${href}"]`)) {
      return resolve();
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;

    link.onload = () => resolve();
    link.onerror = () => resolve(); // fail-safe

    document.head.appendChild(link);
  });
};

export const loadJS = (src) => {
  return new Promise((resolve) => {
    // already loaded
    if (document.querySelector(`script[src="${src}"]`)) {
      return resolve();
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = false;

    script.onload = () => resolve();
    script.onerror = () => resolve(); // fail-safe

    document.body.appendChild(script);
  });
};

export const removeAssets = (keyword) => {
  document
    .querySelectorAll(`link[href*="${keyword}"], script[src*="${keyword}"]`)
    .forEach(el => el.remove());
};
